import React, { useState, useEffect } from "react";
import QrReader from "modern-react-qr-reader";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Button, Typography } from '@mui/material';
import axios from 'axios';
import swal from "sweetalert";

function ScanByQrcode() {
  const [result, setResult] = useState("");
  const [facingMode, setFacingMode] = useState("environment");
  const eventid = localStorage.getItem('eventid');

  // const handleScan = async (data) => {
  //   if (data) {
  //     try {
  //       setResult(data);
  //       const response = await axios.get(`/api/show-single-record-print/${data}`);

  //       if (response.status === 200) {
  //         const detailedData = response.data;

  //         // Open a new tab with a data URI containing the content
  //         const printWindow = window.open();
  //         printWindow.document.write(`
  //             <html>
  //               <head>
  //                 <title>Print</title>
  //                 <style>
  //                   body {
  //                     text-align: center;
  //                     margin: 0;
  //                     padding: 20px;
  //                   }

  //                   #content {
  //                     display: inline-block;
  //                     text-align: left;
  //                     padding-top: 190px;
  //                   }

  //                   #printButton {
  //                     display: block;
  //                     position: fixed;
  //                     top: 0;
  //                     right: 0;
  //                     margin: 20px;
  //                     padding: 10px;
  //                     background-color: green;
  //                     color: white;
  //                     border: none;
  //                     cursor: pointer;
  //                   }

  //                   @media print {
  //                     #printButton {
  //                       display: none;
  //                     }

  //                     /* Remove default browser headers and footers */
  //                     @page {
  //                       size: auto;
  //                       margin: 0;
  //                     }
  //                   }
  //                 </style>
  //                 <script type="text/javascript" src="https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"></script>
  //                 <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.4/dist/JsBarcode.all.min.js"></script>
  //               </head>
  //               <body>
  //                 <!-- Print Button -->
  //                 <button id="printButton" onclick="window.print()">Print</button>

  //                 <div id="content">
  //                   <h1>${detailedData.title}: ${detailedData.name}</h1>
  //                   <p style="text-align: center;">Company Name: ${detailedData.company_name}</p>
  //                   <!-- Include a QR code with the record ID -->
  //                   <div id="qrcode"></div>


  //                   <!-- Include a barcode with the record ID -->
  //                   <div id="barcode-container">
  //                     <svg id="barcode"></svg>
  //                   </div>
  //                   <p style="text-align: center;">ID: ${detailedData.id}</p>
  //                   <script type="text/javascript">
  //                     if (typeof JsBarcode !== 'undefined') {

  //                       // Get the SVG element for the QR code
  //                       const qrcodeSvg = document.getElementById("qrcode");

  //                       // Generate QR code using QRCode
  //                       var qrcode = new QRCode(qrcodeSvg, {
  //                         text: '${data}',
  //                         width: 128,
  //                         height: 128
  //                       });

  //                       // Get the SVG element for the barcode
  //                       const barcodeSvg = document.getElementById("barcode");
  //                       // Generate barcode using JsBarcode
  //                       JsBarcode(barcodeSvg, '${data}', {
  //                         format: "CODE128",
  //                         displayValue: true,
  //                         fontSize: 14,
  //                         textMargin: 10,
  //                       });

  //                       const textElement = barcodeSvg.querySelector('text');
  //                       if (textElement) {
  //                         textElement.remove();
  //                       }
  //                       // Set the desired width directly in the SVG element for the barcode
  //                       barcodeSvg.setAttribute('width', '128'); // Adjust the width here

  //                       // Set the desired height directly in the SVG element for the barcode
  //                       barcodeSvg.setAttribute('height', '80'); // Adjust the height here

  //                       // Disable aspect ratio preservation for the barcode
  //                       barcodeSvg.setAttribute('preserveAspectRatio', 'none');

  //                       // Add spacing between the QR code and the barcode
  //                       qrcodeSvg.style.marginBottom = '20px'; // Adjust the margin here
  //                     } else {
  //                       console.error('JsBarcode library not loaded.');
  //                     }
  //                   </script>
  //                 </div>
  //                 <script>
  //                   // Trigger the print functionality automatically
  //                   window.print();
  //                 </script>
  //               </body>
  //             </html>
  //           `);

  //         // Close the print window after printing
  //         printWindow.document.close();

  //         // Show a success message
  //         swal("Done", `QR Code for ${detailedData.title}: ${detailedData.name} (ID: ${detailedData.id}) printed successfully!`, "success");
  //       } else {
  //         throw new Error('Error fetching record details');
  //       }
  //     } catch (error) {
  //       console.error('Error printing:', error);
  //       swal('Error', 'Error printing record details. Please check your browser settings.', 'error');
  //     }
  //   }
  // };

  const handleScan = async (data) => {
    if (data) {
      try {
        setResult(data);
        const response = await axios.get(`/api/show-single-record-print/${data}/${eventid}`);

        if (response.status === 200) {
          const detailedData = response.data;

          if (!detailedData || Object.keys(detailedData).length === 0) {
            // Display error message if ID is not found or response is empty
            swal('Error', 'ID Not Found.', 'error');
          }
           else {
            // Print data if ID is found
            swal('Success', `Mr ${detailedData.name}  Your ID Print SuccessFully`, 'success');
           
            const barcodeInput = document.getElementById('barcodeInput');
            barcodeInput.focus();
            printData(detailedData, data);
            

          }
        } else {
          throw new Error('Error fetching record details');
        }
      } catch (error) {
        console.error('Error fetching record details:', error);
        //swal('Error', 'Error fetching record details. Please check your network connection.', 'error');
        swal('Success', 'Error fetching record details. Please check your network connection.', 'success');
      }
    }
  };


  const printData = (detailedData, data) => {
    const printWindow = window.open();
    printWindow.document.write(`
  <html>
    <head>
      <title>Print</title>
      <style>
      body {
        text-align: center;
        margin: 0;
        padding: 20px;
      }
    
      #content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: left;
        padding-top: 190px;
      }
    
      #printButton {
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        margin: 20px;
        padding: 10px;
        background-color: green;
        color: white;
        border: none;
        cursor: pointer;
      }
    
      @media print {
        #printButton {
          display: none;
        }
    
        /* Remove default browser headers and footers */
        @page {
          size: auto;
          margin: 0;
        }
      }
    </style>
      <script type="text/javascript" src="https://cdn.rawgit.com/davidshimjs/qrcodejs/gh-pages/qrcode.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.4/dist/JsBarcode.all.min.js"></script>
    </head>
    <body>
      <!-- Print Button -->
      <button id="printButton" onclick="window.print()">Print</button>

      <div id="content">
      <h1 style="margin-bottom: 10px; text-align: center;">${detailedData.name}</h1>
            
      <!-- Include a QR code with the record ID -->
      <div id="qrcode"></div>

      <!-- Include a barcode with the record ID -->
      <!-- <div id="barcode-container">
        <svg id="barcode"></svg>
      </div> -->
      <h2 style="text-align: center;">ID: ${detailedData.id}</h2>
      <h3 style="text-align: center; line-height: 0; margin-top: 0;">${detailedData.company_name}</h3>
      <h3 style="text-align: center; line-height: 0; margin-top: 0;">${detailedData.job_titile}</h3>
        <script type="text/javascript">
          if (typeof JsBarcode !== 'undefined') {

            // Get the SVG element for the QR code
            const qrcodeSvg = document.getElementById("qrcode");

            // Generate QR code using QRCode
            var qrcode = new QRCode(qrcodeSvg, {
              text: '${data}',
              width: 128,
              height: 128
            });

            // Get the SVG element for the barcode
            const barcodeSvg = document.getElementById("barcode");
            // Generate barcode using JsBarcode
            JsBarcode(barcodeSvg, '${data}', {
              format: "CODE128",
              displayValue: true,
              fontSize: 14,
              textMargin: 10,
            });

            const textElement = barcodeSvg.querySelector('text');
            if (textElement) {
              textElement.remove();
            }
            // Set the desired width directly in the SVG element for the barcode
            barcodeSvg.setAttribute('width', '128'); // Adjust the width here

            // Set the desired height directly in the SVG element for the barcode
            barcodeSvg.setAttribute('height', '80'); // Adjust the height here

            // Disable aspect ratio preservation for the barcode
            barcodeSvg.setAttribute('preserveAspectRatio', 'none');

            // Add spacing between the QR code and the barcode
            qrcodeSvg.style.marginBottom = '20px'; // Adjust the margin here
          } else {
            console.error('JsBarcode library not loaded.');
          }
        </script>
      </div>
      <script>
        // Trigger the print functionality automatically
        window.print();
      </script>
    </body>
  </html>
`);

    // Close the print window after printing
    printWindow.document.close();
  };

  useEffect(() => {
    const handleBarcodeScan = (event) => {
      const scannedData = event.target.value;
      handleScan(scannedData);
    };

    const barcodeInput = document.getElementById("barcodeInput");
    console.log("barcodeInput:", barcodeInput); // Check if barcodeInput is not null

    // Add event listener only if barcodeInput is not null
    if (barcodeInput) {
      barcodeInput.addEventListener("change", handleBarcodeScan);
    }

    // Cleanup function to remove event listener when component unmounts
    return () => {
      if (barcodeInput) {
        barcodeInput.removeEventListener("change", handleBarcodeScan);
      }
    };
  }, []);

  const handleError = (err) => {
    console.error(err);
  };

  useEffect(() => {
    handleScan(result);
  }, [result]); // The effect will run whenever the result changes

  const toggleCamera = () => {
    setFacingMode(prevMode => (prevMode === "user" ? "environment" : "user"));
  };

  // const resetResult = () => {
  //   setResult('');
  //   const barcodeInput = document.getElementById('barcodeInput');
  //   barcodeInput.value = '';
  //   barcodeInput.focus();
  // };
  const resetResult = () => {
    setResult('');
    const barcodeInput = document.getElementById('barcodeInput');
    if (barcodeInput) {
      barcodeInput.value = '';
      // Check if the element is focusable before attempting to focus
      if (barcodeInput.focus) {
        barcodeInput.focus();
      } else {
        // If not focusable, set tabIndex to make it focusable
        barcodeInput.tabIndex = 0;
        barcodeInput.focus();
      }
    }
  };




  return (
    <Grid
      container
      spacing={24}
      justify="center"
      style={{ minHeight: '100vh', maxWidth: '100%' }}>
      <Grid item xs={3} align="center">

      </Grid>
      <Grid item xs={12} sm={6} align="center">
        <Typography variant="h4" sx={{ m: 2, mt: 12 }}>Self Scan Qr Code ...</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={toggleCamera}
          sx={{
            marginTop: { xs: 2, sm: 2, md: 3, lg: 4 }, // Adjust marginTop for different screen sizes
            width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' }, // Adjust width for different screen sizes
          }}
        >
          {facingMode === "user" ? "Switch to Back Camera" : "Switch to Front Camera"}
        </Button>
        <TextField id="barcodeInput" type="text" placeholder="Type your barcode" sx={{ m: 2, width: '80%' }} autoFocus />

        <div>
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: '80%' }}
            facingMode={facingMode}/>
          <div>
            {result && (
              <div>
                <Typography variant="h6" sx={{ m: 2 }}>Result:</Typography>
                <Typography>ID: {result}</Typography>
                <Button variant="contained" color="primary" onClick={resetResult}>
                  Clear Result
                </Button>
              </div>
            )}
          </div>
        </div>
      </Grid>
      <Grid item xs={3} align="center">
      </Grid>
    </Grid>
  );
}

export default ScanByQrcode;
